import React, { createContext, useContext } from "react";
import CustomModal from "../components/CustomModal";
import { useCustomModal } from "../hooks/useCustomModal";

interface ModalContextType {
  showAlert: (header: string, message: string, onConfirm?: () => void) => void;
  showConfirm: (
    header: string,
    message: string,
    onConfirm?: () => void,
    onCancel?: () => void,
  ) => void;
  showPrompt: (
    header: string,
    message: string,
    inputs: Array<{
      name: string;
      type: "text" | "email" | "password" | "number";
      placeholder: string;
      value?: string;
    }>,
    onConfirm?: (data: any) => void,
    onCancel?: () => void,
  ) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { isOpen, config, hideModal, showAlert, showConfirm, showPrompt } =
    useCustomModal();

  const contextValue: ModalContextType = {
    showAlert,
    showConfirm,
    showPrompt,
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <CustomModal
        isOpen={isOpen}
        onDidDismiss={hideModal}
        header={config.header}
        message={config.message}
        inputs={config.inputs}
        buttons={config.buttons}
      />
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
